import { Box, Typography, IconButton, Card } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import filterIcon from "../../../../assest/images/filter.svg";

const ReportDefaultUi = ({ setOpen, text }) => {
  return (
    <Box>
      {/* <Typography variant="h6" fontWeight={600} sx={{ padding: "20px" }}>
        Apply filter to view the report
      </Typography> */}
      <Typography sx={{ lineHeight: "1", padding: "20px" }} variant="subtitle2">
        Apply filters to refine and display the relevant data based on your
        selected criteria.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
        <img src={filterIcon} style={{ width: "35%", height: "30%" }} />
      </Box>
    </Box>
  );
};

export default ReportDefaultUi;
